import { createSlice } from "@reduxjs/toolkit";
import { addCustomerAPI } from "../../api/customer";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const addCustomerSlice = createSlice({
  name: "addCustomer",
  initialState: data,
  reducers: {
   addCustomerSlice(state) {
      state.isLoading = true;
    },
   addCustomerSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    addCustomerSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
   addCustomerSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const addCustomerHandler = (data:any) => async (dispatch: any) => {
  try {
    dispatch(addCustomerAction.addCustomerSlice());
    const response: any = await addCustomerAPI(data);
    
    dispatch(addCustomerAction.addCustomerSliceSuccess(response));
  } catch (e: any) {
    dispatch(addCustomerAction.addCustomerSliceFailure(e?.response?.data));
  }
};
export default addCustomerSlice.reducer;
export const addCustomerAction = addCustomerSlice.actions;
